import React, { useState } from 'react';
import Login from './Login';
import Register from './Register';

interface AuthModalProps {
  isOpen?: boolean;
  mode?: 'login' | 'register';
  onClose: () => void;
  initialMode?: 'login' | 'register';
  onSuccess?: () => void;
  onSwitchMode?: () => void;
}

const AuthModal: React.FC<AuthModalProps> = ({
  isOpen = true,
  mode: propMode,
  onClose,
  initialMode = 'login',
  onSuccess,
  onSwitchMode
}) => {
  const [mode, setMode] = useState<'login' | 'register'>(propMode || initialMode);

  if (isOpen === false) return null;

  const handleSuccess = () => {
    if (onSuccess) onSuccess();
    onClose();
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 sm:p-5 animate-fade-in"
      onClick={handleBackdropClick}
    >
      <div className="relative w-full max-w-[500px] max-h-[90vh] overflow-auto animate-slide-in">
        <button
          className="absolute top-5 right-5 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-white/90 border-none text-2xl text-gray-500 cursor-pointer transition-all duration-200 hover:bg-white hover:scale-110"
          onClick={onClose}
        >
          ×
        </button>

        <div>
          {mode === 'login' ? (
            <Login
              onSwitchToRegister={() => setMode('register')}
              onSuccess={handleSuccess}
            />
          ) : (
            <Register
              onSwitchToLogin={() => setMode('login')}
              onSuccess={handleSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
